// Set this to your own publicKey to unlock the admin report-review view.
// Find your pubkey by running this in the browser console while signed in:
//   JSON.parse(localStorage.getItem('authenticulture_identity')).publicKey
export const ADMIN_PUBKEY = 'ksOfP0iLHCeHyH/DCpbl8VGgq4qif3ko8uxORsaDjqg=';

export function isAdmin(pubkey: string): boolean {
  return ADMIN_PUBKEY.length > 0 && pubkey === ADMIN_PUBKEY;
}

export type ReportTargetType = 'post' | 'video' | 'event_listing' | 'community' | 'listing';
export type ReportReason = 'spam' | 'harassment' | 'illegal' | 'other';

export interface ContentReport {
  id: string;
  reporterPubkey: string;
  targetId: string;
  targetType: ReportTargetType;
  reason: ReportReason;
  note?: string;
  createdAt: number;
}

const REPORTS_KEY = 'authenticulture_content_reports';
const MAX_REPORTS = 1000;

export function getAllReports(): ContentReport[] {
  const stored = localStorage.getItem(REPORTS_KEY);
  return stored ? JSON.parse(stored) : [];
}

export function saveContentReport(report: ContentReport): void {
  const reports = getAllReports();
  if (reports.some(r => r.id === report.id)) return;
  reports.unshift(report);
  if (reports.length > MAX_REPORTS) reports.splice(MAX_REPORTS);
  localStorage.setItem(REPORTS_KEY, JSON.stringify(reports));
}

export function dismissReport(id: string): void {
  const reports = getAllReports().filter(r => r.id !== id);
  localStorage.setItem(REPORTS_KEY, JSON.stringify(reports));
}
